// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"0e2f751f","84":"24cfebf6","247":"3444f7be","453":"e5b00392","627":"7b46e56e","834":"abea0555","867":"d65bb103","923":"45520ddd"}[chunkId] + ".chunk.js";
};